import { Image } from "@kirvanobr/image";
import { Edit02 } from "@untitled-ui/icons-react";
import SpinnerDotsIcon from "./icons/SpinnerDotsIcon";
import { useThumbStore } from "./Thumb.store";
import { styles as s } from "./Thumb.styles";
import { ThumbModalProps, ThumbProps } from "./Thumb.types";
import ThumbModal from "./ThumbModal";

export const Thumb = ({ defaultImageUrl, handleUploadLogo, closeUploadModal }: ThumbProps & ThumbModalProps) => {
  const openUploadModal = useThumbStore(state => state.openUploadModal);

  return (
    <div className={s().previewContainer()}>
      <div className={s().base()} onClick={openUploadModal}>
        {defaultImageUrl ? (
          <>
            <span className={s().thumbButtons()}>
              <Edit02 className={s().icon()} onClick={openUploadModal} />
            </span>
            <Image
              className={s().img()}
              src={defaultImageUrl}
              radius="none"
              width={400}
              height={230}
              alt="Video thumbnail"
              loading="lazy"
            />
          </>
        ) : (
          <SpinnerDotsIcon />
        )}
      </div>
      <ThumbModal handleUploadLogo={handleUploadLogo} closeUploadModal={closeUploadModal} />
    </div>
  );
};
